export const SET_ID_CRM_ACTION = "SET_ID_CRM";
export const SET_DNI_ACTION = "SET_DNI";
export const SET_ID_USER_ACTION = "SET_ID_USER";
export const SET_LOADING_ON_ACTION = "LOADING_ON";
export const SET_LOADING_OFF_ACTION = "LOADING_OFF";
export const SET_ALERT_ACTION = "SET_ALERT";
export const SET_TENANT_ACTION = "SET_TENANT";
export const SET_ID_LOGIN_ACTION = "SET_ID_LOGIN";
export const SET_SEARCH_TAB_ACTION = " SET_SEARCH_TAB";
export const SET_USER_TYPE_ACTION = " SET_USER_TYPE";
export const SET_USER_ALIAS_ACTION = " SET_USER_ALIAS";
export const SET_TENANTS_ACTION = " SET_TENANTS";
